const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/blog/$postId/edit.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/blog/$postId/edit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});